import { SlidersHorizontal, Wrench } from "lucide-react";
import { Badge } from "@/components/ui/badge.jsx";

/**
 * Pill showing a mapped Mech / Non-Mech classification.
 * Renders nothing when `isMech` is null or undefined.
 * @param {Object} props
 * @param {boolean|null|undefined} props.isMech
 * @returns {JSX.Element|null}
 */
export default function ClassificationStatusPill({ isMech }) {
  if (isMech === null || isMech === undefined) {
    return null;
  }

  if (isMech) {
    return (
      <Badge
        variant='outline'
        className='gap-1 border-red-500 bg-red-50 text-red-600 font-medium'>
        <Wrench className='h-3.5 w-3.5' />
        Mech
      </Badge>
    );
  }

  return (
    <Badge
      variant='outline'
      className='gap-1 border-blue-500 bg-blue-50 text-blue-600 font-medium'>
      <SlidersHorizontal className='h-3.5 w-3.5' />
      Non-Mech
    </Badge>
  );
}
